import toolDefinitions from "./definitions.json";
export const TOOL_VERSION = '1.0';
export const PLAN_NAMES = ['none', 'plan1', 'plan2', 'plan4', 'plan5', 'postgrad'];
export const definitions = toolDefinitions;

/** Validate the entire supported flat contract before invoking permissive UI engines. */
export function validateArguments(schema, input) {
  if (!input || typeof input !== 'object' || Array.isArray(input)) return 'Supply an object containing the required fields.';
  if (Object.keys(input).some(key => !Object.prototype.hasOwnProperty.call(schema.properties, key))) return 'Unsupported fields supplied. Use the full website for additional circumstances.';
  for (const name of schema.required) {
    const rule = schema.properties[name];
    if (!Object.prototype.hasOwnProperty.call(input, name)) return `Missing required field: ${name}.`;
    if (typeof input[name] !== rule.type || (rule.enum && !rule.enum.includes(input[name]))) return `Unsupported value for ${name}.`;
    if (rule.type === 'number' && (!Number.isFinite(input[name]) || input[name] < rule.minimum || input[name] > rule.maximum)) return `Out-of-range value for ${name}.`;
  }
  return null;
}
